// extracted by mini-css-extract-plugin
module.exports = {"row":"EditableText_row__2YgQ9","input":"EditableText_input__3o2L5","editButton":"EditableText_editButton__3E2L-"};